import { createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием загрузки PDF
// нужен чтобы отслеживать состояние загрузки PDF файлов пока текущие файлы не загружены, новые не удастся загрузить
// блокировалась кнопка загрузки PDF
export const UploadImage = createSlice({
    name: "uploadImage",
    initialState: {
        upload:false,
    },
    reducers: {
        onChangeUploadImage: (state, {payload}) => {
            state.upload = payload.upload;
            return state;
        },
    },

});

export const { onChangeUploadImage } = UploadImage.actions;
export const UploadImageSelector = (state) => state.uploadImage;